<div class="container-fluid" *ngIf="!loading; else loader">
  <div class="row">
    <div class="col-12 mb-2">
      <mat-checkbox [(ngModel)]="allowSchedule" (change)="onAllowSchedule($event)" class="schedule-checkbox" #schedule>
        Schedule a restart or a shutdown</mat-checkbox>
    </div>
    <form [formGroup]="form">
      <div class="col-12 d-flex">
        <mat-radio-group formControlName="action">
          <mat-radio-button [value]="actions.Restart" class="mr-3">Restart</mat-radio-button>
          <mat-radio-button [value]="actions.ShutDown" class="mr-3">Shut down</mat-radio-button>
          <mat-radio-button [value]="actions.RestartApp">Restart app</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-12 mt-2 mb-3 d-flex">
        <div class="time">
          @switch (getFormValue('action')) {
            @case (actions.Restart) {
              <timepicker formControlName="restartTime"></timepicker>
            }
            @case (actions.ShutDown) {
              <timepicker formControlName="shutdownTime"></timepicker>
            }
            @case (actions.RestartApp) {
              <timepicker formControlName="restartAppTime"></timepicker>
            }
          }
        </div>
      </div>

      <div class="col-12 mb-3 mt-5">
        <div class="col-12 p-0">
          <mat-checkbox [(ngModel)]="allowScheduleMonitors" [ngModelOptions]="{standalone: true}"
            class="schedule-checkbox">
            Schedule monitors to On and Off</mat-checkbox>
        </div>

        <div class="d-flex align-items-center justify-content-between">
          <label for="TurnOffMonitors" matTooltip="Turn Off all monitors at the same time">
            Turn Off monitors at:
          </label>
          <timepicker [disabled]="!allowScheduleMonitors" [(ngModel)]="displaysOff"
            [ngModelOptions]="{standalone: true}"></timepicker>
        </div>

        <div class="d-flex align-items-center justify-content-between">
          <label for="TurnOnMonitors" matTooltip="Turn On all monitors at the same time">
            Turn On monitors at:
          </label>
          <timepicker [disabled]="!allowScheduleMonitors" [(ngModel)]="displaysOn"
            [ngModelOptions]="{standalone: true}"></timepicker>
        </div>
      </div>

      <div class="col-12 d-flex justify-content-end p-0">
        <button matTooltip="Cancel" mat-raised-button type="button" class="mr-3" (click)="cancel()">
          Cancel
        </button>
        <button matTooltip="Save set time schedule" mat-raised-button type="button" (click)="send()">Save</button>
      </div>
    </form>
  </div>
</div>
<ng-template #loader>
  <div class="d-flex align-items-center justify-content-center h-100">
    <app-loader></app-loader>
  </div>
</ng-template>
